export default __webpack_public_path__ + "static/media/pantry1-afterE-2048w.ec1fcfcf.webp";